export default {
    notes_create_new_note: "Nueva Nota",
    notes_create_edit_note: "Editar Nota",
    notes_create_success_message: "Se ha creado la nota",
    notes_update_success_message: "La nota ha sido editada",
    notes_note: "Nota",
    notes_create_show_note: "Ver",
    notes_min_length: "La no ta debe tener al menos 3 carácteres",
}